export const GET_WORKSPACE_TEAMS = "GET_WORKSPACE_TEAMS";
export const SET_ACTIVE_WORKSPACE_TEAM = "SET_ACTIVE_WORKSPACE_TEAM";
export const UPDATE_TOKEN = "UPDATE_TOKEN";
export const GET_WORKSPACE_SETTINGS = "GET_WORKSPACE_SETTINGS";
export const UPDATE_WORKSPACE_TEAM = "UPDATE_WORKSPACE_TEAM";
